export const PILLAR_MESSAGE_ID = "PillarMessageId";
export const PILLAR_HIGHLIGHT_TEXT_ID = "PillarHighlightTextId";
export const PILLAR_MESSAGE_TEXT_ID = "PillarMessageTextId";
export const PILLAR_MESSAGE_LEARN_MORE_ID = "PillarMessageLearnMoreId";
export const PILLAR_MESSAGE_HELP_ID = "PillarMessageHelpId";
